import { Box, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ErrorBoundary from '../../../../../components/material-ui/error_boundary/ErrorBoundary';
import CasinoDomainsTable from '../../../../../components/casino/CasinoDomainsTable';
import CusButton from '../../../../../components/material-ui/CusButton';
import { API_CASINO } from '../../../../../api/casino';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import useToast from '../../../../../hooks/useToast';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';

export default function DomainContent() {
  const { casinoId } = useParams();
  const { t } = useTranslation();
  const { successToast, errorToast } = useToast();

  const [domains, setDomains] = useState([]);

  useEffect(() => {
    API_CASINO.get
      .props({ casinoId: +casinoId, propsCasino: ['domainList'] })
      .then((e) => {
        const info = e.data.info;
        setDomains(info.domainList);
      })
      .catch(console.error);
  }, [casinoId]);

  const onSaveClick = () => {
    const hasDuplicateNames = (arr) => new Set(arr.map((item) => item.name)).size !== arr.length;

    const isDuplicate = hasDuplicateNames(domains);
    if (isDuplicate) {
      errorToast('Remove duplicates from the list of domains');
      return;
    }

    if (domains.some((el) => !el.name)) {
      errorToast('Please specify a name for all domains');
      return;
    }

    API_CASINO.update({ casinoId: +casinoId, domainList: domains })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  return (
    <Stack display={'flex'} direction={'column'} gap={1}>
      <Box>
        <ErrorBoundary>
          <CasinoDomainsTable prohibitDefaultDelete domains={domains} setDomains={setDomains} />
        </ErrorBoundary>
        <CasinoBtnSave onClick={onSaveClick} sx={{ mt: 2 }} />
      </Box>
    </Stack>
  );
}
